/* tslint:disable */
/* eslint-disable */
/**
 * Datenbankgestalter.de API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ApplicationScope } from './ApplicationScope';
import {
    ApplicationScopeFromJSON,
    ApplicationScopeFromJSONTyped,
    ApplicationScopeToJSON,
} from './ApplicationScope';
import type { TenantOrderDetails } from './TenantOrderDetails';
import {
    TenantOrderDetailsFromJSON,
    TenantOrderDetailsFromJSONTyped,
    TenantOrderDetailsToJSON,
} from './TenantOrderDetails';

/**
 * 
 * @export
 * @interface MyDbOrderDetails
 */
export interface MyDbOrderDetails extends TenantOrderDetails {
}

/**
 * Check if a given object implements the MyDbOrderDetails interface.
 */
export function instanceOfMyDbOrderDetails(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function MyDbOrderDetailsFromJSON(json: any): MyDbOrderDetails {
    return MyDbOrderDetailsFromJSONTyped(json, false);
}

export function MyDbOrderDetailsFromJSONTyped(json: any, ignoreDiscriminator: boolean): MyDbOrderDetails {
    return json;
}

export function MyDbOrderDetailsToJSON(value?: MyDbOrderDetails | null): any {
    return value;
}

